import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { AdjustmentDosageTimeRange } from "../../response/computation/data-responses/parts/adjustment-dosage-time-range";
import { DosageTimeRange } from "./dosage-time-range";

export class DrugTreatment implements RequestModelInterface
{
    public dosageTimeRanges: Array<DosageTimeRange|AdjustmentDosageTimeRange> = [];

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("treatment");
        const historyElement = element.appendNewElement("dosageHistory");

        historyElement.appendChildren(this.dosageTimeRanges);

        return element;
    }
}
